/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */

import { path } from 'rambda';

import { defineModule } from 'direct-vuex';
import { modActionCtx, modGetterCtx } from '@/store/index';
import { api } from '@/utils/apiInstance';

import {
  FetchOfficeState,
  getFetchState,
  getFetchMutations,
  basicOfficeFetch,
} from '@/store/storeUtils';
import {
  PENDING, REJECTED,
} from '@/utils/statuses';

export interface LoanPointsInterface {
  0: number | string,
}

type StateInterface = FetchOfficeState<LoanPointsInterface>;

const loanPointsStore = defineModule({
  namespaced: true,
  state: {
    ...getFetchState<StateInterface>(),
  } as StateInterface,

  getters: {
    data(...args): LoanPointsInterface {
      const { state } = getterCtx(args);

      const result = path('data.data', state.response) as LoanPointsInterface;

      return result;
    },
  },
  mutations: {
    ...getFetchMutations(),
  },
  actions: {

    async fetch(ctx) {
      const { commit, state } = actionCtx(ctx);

      if (state.fetchState === PENDING) {
        return;
      }

      await basicOfficeFetch({
        method: api.office.sendPost,
        props: {
          url: '/loan/loanPoints',
          data: {},
        },
        setState: commit.SET_STATE,
        // update state
        callback: (fetchState) => {
          if (fetchState === REJECTED) {
            console.error('Fetch error in loanPointsStore.fetch, status: ', REJECTED);
          }
        },
      });
    },
  },
});

export default loanPointsStore;
const getterCtx = (args: [any, any, any, any]) => modGetterCtx(args, loanPointsStore);
const actionCtx = (ctx: any) => modActionCtx(ctx, loanPointsStore);
